import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { BaseSortTransformation } from './basesorttransformation';
import { DataFlowColumn } from '../dataset/dataflowcolumn';
import { Owned } from '../base/named';
import { ExpressionBasedColumn } from './expression-based.column';
import { LongDataFlowType, BooleanDataFlowType } from './dataflow-datatype';
import { IExtraFieldInfo } from 'app/interfaces/IExtraFieldInfo';
import { validateColumn, keyTransformationOutputColumns, IKeyColumnTransformation, getInspectSummaryOutputFields, getInspectDetailsOutputFields } from './keytransformation.utils';
import { DataFlowExpression } from './dataflowexpression';

@Metamodel.model({
    name: 'rank',
    display: [stringResources.DataFlowRankTransformationLabel, stringResources.DataFlowRankTransformationsLabel],
    referable: true,
    constraints: {
        name: {
            required: true
        }
    }
})
export class RankTransformation extends BaseSortTransformation implements IKeyColumnTransformation {
    public static readonly MODEL: IModel;

    public inspectSummaryOutputFields = getInspectSummaryOutputFields(this);

    public inspectDetailsOutputFields: IExtraFieldInfo[] = getInspectDetailsOutputFields(this, stringResources.RankColumnName).concat(
        {
            name: () => stringResources.TransformationInspect_Column_Ordered,
            icon: this._isAscending.bind(this)
        }
    );

    public dense: DataFlowExpression = this.createTemplatableExpression(BooleanDataFlowType.TYPE, 'false');
    public newColumn: boolean = true;

    @Metamodel.attribute({
        type: ExpressionBasedColumn.MODEL,
        constraint: {
            required: true,
            validator: validateColumn
        }
    })
    public keyColumn: DataFlowColumn = Owned.create<DataFlowColumn>(DataFlowColumn.MODEL, this);

    public constructor() {
        super();
        this.keyColumn.dataFlowColumnType = new LongDataFlowType();
    }

    protected getGeneratedDescription(): string {
        return this._getGeneratedDescriptionInteral(stringResources.RankDescription, stringResources.RankNoExpressionDescription);
    }

    protected _outputColumns(): DataFlowColumn[] {
        return keyTransformationOutputColumns(this, this.inputColumns);
    }
}
